import { Component } from 'angular-ts-decorators';

import {
  faBuilding,
  faHome,
  faInfoCircle,
  faLifeRing,
  faUser,
} from '@fortawesome/pro-solid-svg-icons';

/**
 * Component that displays the gate's main menu.
 */
@Component({
  selector: 'gateMainMenu',
  template: require('./gate-main-menu.html').default,
})
export class GateMainMenuComponent {
  faBuilding = faBuilding;
  faUser = faUser;
  faHome = faHome;
  faLifeRing = faLifeRing;
  faInfoCircle = faInfoCircle;
}
